export var FEEDBACK_SUCCESS = 'Copied to clipboard!';
export var FEEDBACK_ERROR = 'Could not copy to clipboard.';